import { Building } from "../Building";
import { RoofAddon } from "../../scene/addon/RoofAddon";
import { MaterialManager } from "../../material/MaterialManager";
import { Main } from "../../Main";

export class PeakBoxTrim
{

	private _building : Building;

	private _front : RoofAddon;
	private _back  : RoofAddon;

	constructor(building:Building)
	{
		this._building = building;
		this.init();
	}

	private init = () =>
	{
		var peakBoxConfig = {
			"id": "",
			"label": "Low Profile Vent",
			"mesh": {
				"1": "#0940 - Peak Box for 1440 Rake - 1/12 Pitch",
				"2": "#0940 - Peak Box for 1440 Rake - 2/12 Pitch",
				"3": "#0940 - Peak Box for 1440 Rake - 3/12 Pitch",
				"4": "#0940 - Peak Box for 1440 Rake - 4/12 Pitch",
				"5": "#0940 - Peak Box for 1440 Rake - 4/12 Pitch"
			},
			"type": "roof",
			"size": {
				"length": 0
			},
			"material": MaterialManager.getInstance().trim,
			"pitch": this._building.config.building.pitch
		};

		this._front = new RoofAddon(peakBoxConfig);

		this._front.addToScene(this._building.scene3D);
		this._front.show();

		this._back = new RoofAddon(peakBoxConfig);

		this._back.addToScene(this._building.scene3D);
		this._back.show();

		this._building.config.building.propertyChange.add(this.update);
		this._building.config.building.pitch.signal.add(this.update);
		this._building.config.building.single_slope.signal.add(this.update);

		var insetBay = Main.getInstance().config.building.insetBay;
		insetBay.front.count.signal.add(this.update);
		//insetBay.front.drop.signal.add(this.update);
		insetBay.back.count.signal.add(this.update);
		//insetBay.back.drop.signal.add(this.update);

		this.update();
	};

	private update = () =>
	{
		var metrics = this._building.config.metrics;

		var offset_z = 0.2;
		var offset_y = 0.26 + Math.max(metrics.overhang_left, metrics.overhang_right)/100 + metrics.pitch/100;;

		var frontContainer = this._front.container;
		frontContainer.position.z = metrics.length_half + metrics.overhang_front + offset_z;
		frontContainer.position.x = 0;
		frontContainer.position.y = metrics.top + offset_y;

		var backContainer = this._back.container;
		backContainer.position.z = -metrics.length_half - metrics.overhang_back - offset_z;
		backContainer.position.x = 0;
		backContainer.position.y = metrics.top + offset_y;
		backContainer.rotation.y = Math.PI;

		var insetBay = Main.getInstance().config.building.insetBay;
		if (insetBay.front.count.value > 0)// && insetBay.front.drop.value === 0)
		{
			this._front.hide();
		}
		else
		{
			this._front.show();
		}
		if (insetBay.back.count.value > 0)// && insetBay.back.drop.value === 0)
		{
			this._back.hide();
		}
		else
		{
			this._back.show();
		}

		var single_slope = this._building.config.building.single_slope.value;
		if (single_slope && single_slope)
		{
			// new version: hide peakbox

			this.hide();

			// previously: show peakbox (rotate it)
			//var rot_sign = 1;
			//if (single_slope)
			//{
			//	rot_sign = -1;
			//}
			//
			//frontContainer.rotation.z = -metrics.alpha * rot_sign;
			//frontContainer.position.y += 0.45 * metrics.tan;
			//
			//backContainer.rotation.z = metrics.alpha * rot_sign;
			//backContainer.position.y += 0.45 * metrics.tan;
		}
		else
		{
			//frontContainer.rotation.z = 0;
			//backContainer.rotation.z = 0;

			//this.show()
		}
	}

	private hide()
	{
		this._back.hide();
		this._front.hide();
	}

	private show()
	{
		this._back.show();
		this._front.show();
	}
}
